<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">Berechnung eines Umsatzzieles / Umsatzsteigerung über einen prozentualen Wert</h4>

      </div>
    </div>
    <div class="row">
      <div :class="calcValues.turnoverGrowthAbsolute.isResult ? 'col-lg-7' : 'col-16' ">
      
        <div class="row mt-3">
          <div class="col-16">
            
            <label class="form-label">Umsatz vorher</label>


            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatTurnoverOld" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.turnoverOld.suffix"></span>
            </div>
            

            <label class="form-label">Umsatzziel</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatTurnoverGrowthPercent" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.turnoverGrowthPercent.suffix"></span>
            </div>
          
            
          </div>

        </div>
      </div>
      <div class="col-lg-8 offset-lg-1"  v-if="calcValues.turnoverGrowthAbsolute.isResult">
        <h5>Ergebnis</h5>
        Wenn Du Deinen Umsatz um <span class="sb-bold">{{ calcValues.turnoverGrowthPercent.formatted }} <span v-html="calcValues.turnoverGrowthPercent.suffix"></span></span> verändern möchtest, dann beträgt Dein Umsatzziel: <span class="sb-bold">{{ calcValues.turnoverNew.formatted }} <span v-html="calcValues.turnoverNew.suffix"></span></span>.
        <div v-if="calcValues.turnoverGrowthAbsolute.number > 0">
          Somit muss sich Dein Umsatz um <span class="sb-bold">{{ calcValues.turnoverGrowthAbsolute.formatted }} <span v-html="calcValues.turnoverGrowthAbsolute.suffix"></span> erhöhen.</span>
        </div>

        <div
          v-if="calcValues.turnoverGrowthAbsolute.number < 0">
          Somit muss sich Dein Umsatz um <span class="sb-bold">{{ calcValues.turnoverGrowthAbsolute.formatted }} <span v-html="calcValues.turnoverGrowthAbsolute.suffix"></span> vermindern.</span>
        </div>

        <div v-if="calcValues.turnoverGrowthAbsolute.number == 0">
          Somit wäre Dein Umsatz <span class="sb-bold">unverändert.</span>
        </div>

      </div>
    </div>

 </div>
</template>

<script>
export default {
  name: "turnoverGrowth2Absolute",
  data() {
    return {
      calcValues: {
        turnoverOld: {
          number: 0,
          formatted: '',
          suffix: '&euro;'
        },
        turnoverNew: {
          number: 0,
          formatted: '',
          suffix: '&euro;'
        },
        turnoverGrowthPercent: {
          number: 0,
          formatted: '',
          suffix: '%',
        },
        turnoverGrowthAbsolute: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
      }

    }
  },
  computed: {
    formatTurnoverOld: {
      get () {
        return this.getObj('turnoverOld').number;
      },
      set (value) {
        return this.setObj('turnoverOld', value, 1);
      }
    },
    formatTurnoverGrowthPercent: {
      get () {
        return this.getObj('turnoverGrowthPercent').number;
      },
      set (value) {
        return this.setObj('turnoverGrowthPercent', value, 1);
      }
    },
  },
  methods: {
    formatStr2Number(str) {
      var number = Number(str.toString().replace(',','.'));
      //console.log(number, typeof number);
      if (isNaN(number)) number = 0;
      return number;
    },
    setResult(name, result) {
      let obj = this.getObj(name);
      obj.isResult = result;
      this.calcValues[name] = obj;
    },
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.formatStr2Number(value);
      obj.formatted = this.beautifier(obj.number);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();

      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    beautifier(value) {
      return Number(value).toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    calcResult() {

      let old = this.calcValues.turnoverOld;
      let tnew = this.calcValues.turnoverNew;
      let percent = this.calcValues.turnoverGrowthPercent;
      let absolute = this.calcValues.turnoverGrowthAbsolute;

      //Formel: (old / 100 * percent) + old

      tnew.number = (old.number / 100 * percent.number) + old.number;
      this.setObj('turnoverNew', tnew.number, 0);

      absolute.number = (tnew.number - old.number);
      absolute.isResult = true;
      this.setObjContent('turnoverGrowthAbsolute', absolute, 0);
    }
  }
}
</script>

<style scoped>

</style>